import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Bar, Doughnut, Line } from "react-chartjs-2";

import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from "chart.js";
import { DashBoardService } from "../../services/DashBoardService";
import * as BullCache from "../../util/BullCache";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

function AdminDashboard() {

     var user = BullCache.getFromCache("user");
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
    const [orderStatus,setOrderStatus] = useState([]);
    const [userMap,setUserMap] = useState([]);
    const [ordersMap,setOrdersMap] = useState([]);
    const [ordersByHourMap,setOrdersByHourMap] = useState([]);
    const [totalOrderStatus, setTotalOrderStatus] = useState(0);

        useEffect(() => {
        DashBoardService.getAll2({'adminId':user.adminId}).then(res=>{
            if(res.code===1){
                setOrderStatus(res.data.orderStatus);
                setUserMap(res.data.usersMap);
                setOrdersMap(res.data.ordersMap);
                setOrdersByHourMap(res.data.ordersByHourMap);
            }
        });
    
    },[]);

     useEffect(() => {
        setTotalOrderStatus(orderStatus.trades+orderStatus.pendingOrders+orderStatus.rejectionLogs);
    },[orderStatus]);

    const labels = Object.keys(ordersMap);
    const data = Object.values(ordersMap);

    const tradesData = {
        labels: labels,
        datasets: [
            {
                label: "Trade By Dates",
                data: data,
                backgroundColor: "#8BC34A",
                borderColor: "#8BC34A",
                borderWidth: 1,
            },
        ],
    };

    const pieData = {
        labels: ["Executed Orders", "Pending Orders", "Rejected Orders"],
        datasets: [
            {
                label: "Trade By Valan",
                data: [orderStatus.trades, orderStatus.pendingOrders, orderStatus.rejectionLogs],
                backgroundColor: [ "#8BC34A", "#FFAB40", "#FF4A4A" ],
                hoverBackgroundColor: [ "#FFB300", "#E53935", "#FF4A4A"],
                borderWidth: 0,
            },
        ],
    };

     const options = {
         responsive: true,
        maintainAspectRatio: false,
         plugins: {
           datalabels: {
                color: '#fff',
                font: {
                    size: 12,
                }
            }
        }
        };

    const lineChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: '#ccc', // optional: legend text color
                },
            },
           datalabels: {
                color: '#fff',
                font: {
                    size: 18,
                }
            }
        }
    };

         const orderStatusOptions = {
              maintainAspectRatio: false,
            plugins: {
                legend: {
                position: 'right',
                labels: {
                    color: '#ccc', // optional: legend text color
                },
                },
                datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 12,
                },
                formatter: (value, context) => {
                    return `${value}`;
                }
                },
            },
        };

    const hours = Object.keys(ordersByHourMap);
    const hoursData = Object.values(ordersByHourMap);

    const lineChartData = {
        labels: hours,
        datasets: [
            {
                label: "Hourly Orders",
                data: hoursData,
                borderColor: "#8BC34A",
                backgroundColor: "#8BC34A",
                borderWidth: 2,
            },
        ],
    };

    return (
        <Card>
            <Card.Body className="mb-4">
                <Row className="p-3">
                    <Col className="col-1 me-3">
                        <Row>
                            <Card className="mb-3" border="light">
                                <Card.Body className="text-center">
                                    <h6 style={{ color: "#18FFFF" }}>{userMap.admin} <br /> Admins</h6>
                                </Card.Body>
                            </Card>
                        </Row>
                        <Row>
                            <Card className="mb-3" border="light">
                                <Card.Body className="text-center">
                                    <h6 style={{ color: "#18FFFF" }}>{userMap.master} <br /> Masters</h6>
                                </Card.Body>
                            </Card>
                        </Row>
                        <Row>
                            <Card className="mb-3" border="light">
                                <Card.Body className="text-center">
                                    <h6 style={{ color: "#18FFFF" }}>{userMap.subbroker} <br /> Broker</h6>
                                </Card.Body>
                            </Card>
                        </Row>
                        <Row>
                            <Card border="light">
                                <Card.Body className="text-center">
                                    <h6 style={{ color: "#18FFFF" }}>{userMap.user}<br /> Users</h6>
                                </Card.Body>
                            </Card>
                        </Row>
                    </Col>

                    <Col className=" me-3">
                        <Row>
                            <Card className="mb-3" style={{ height: 370 }} border="light">
                                <Card.Body>
                                    <h5 className="text-center">Trade By Dates</h5>
                                    <div style={{ width: "100%", height: "90%", margin : "0 auto", marginTop:"0"}}>
                                        <Bar data={tradesData} options={options}/>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Row>
                    </Col>

                    <Col className="">
                        <Row>
                            <Card border="light" style={{ height: 370 }}>
                                <Card.Body>
                                    <h5 className="text-center">Trade By Valan</h5>
                                    <div className="text-center mt-3">
                                        <h6>Total Orders: {totalOrderStatus}</h6>
                                    </div>
                                    <div style={{ width: "80%", height: "75%", margin : "0 auto", marginTop:"0"}}>
                                        <Doughnut data={pieData} options={orderStatusOptions}   width={150}
                                                height={150}/>
                                    </div>
                                    
                                </Card.Body>
                            </Card>
                        </Row>
                    </Col>
                </Row>

                <Row className="mt-2 p-1">
                    <Col xl={12}>
                        <Card border="light">
                            <Card.Body>
                                <div >
                                    <input
                                        type="date"
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                        className="form-control w-auto"
                                    />
                                </div>
                                <h5 className="text-center">Hourly Orders</h5>
                                <div style={{ height: "400px" }}>
                                    <Line data={lineChartData} options={lineChartOptions} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>


            </Card.Body>
        </Card>
    );
}

export default AdminDashboard;
